module.exports = __webpack_public_path__ + "img/refresh.7185a076.svg";